const initGeoDropdown = (geoDropdown) => {
  const geoDropdownButtons = geoDropdown.querySelector('[data-buttons]')

  /** 
   * Cookie handling
   */

  const setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

 /**
   * Popup Render Html
   */

  const redirectUrl = () => {

    const currentUrl = window.location.href;
    const pathname = new URL(currentUrl).pathname;

    const redirectTag = 'rdrct=true';

    if (pathname)
    {
       let redirectUrl = pathname;

      if (redirectUrl.includes('?'))
      {
        redirectUrl = pathname + '&' + redirectTag
      }
      else
      {
        redirectUrl = pathname + '?' + redirectTag
      }

      return redirectUrl
    }
    else
    {
      return '?' + redirectTag
    }
  }

  const createButton = (language) => {

    const name = language.name,
      countryCode = language.countryCode.split(',')[0].toUpperCase(),
      src = language.src,
      url = language.url,
      currentShopLanguange = language.currentLanguange;

    if (currentShopLanguange == true)
    {
      return `
    <li class="geo-dropdown__language geo-dropdown__language--current">
        <div>
            <span>${ name }</span>
        </div>
    </li>
      `;
      // return `
      // <li class="geo-dropdown__language geo-dropdown__language--current">
      //     <div>
      //         <span>${ countryCode }</span>
      //         <img loading="lazy" src="${ src }" alt="">
      //     </div>
      // </li>
      //   `;
    }
    else
    {
      const pUrl = redirectUrl();
      return `
          <li class="geo-dropdown__language">
              <a href="${ url + pUrl }">
                  <span>${ name }</span>
              </a>
          </li>
      `;
  //     return `
  //     <li class="geo-dropdown__language">
  //         <a href="${ url + pUrl }">
  //             <span>${ countryCode }</span>
  //             <img loading="lazy" src="${ src }" alt="">
  //         </a>
  //     </li>
  // `;
    }
  }




  const buttonClickHandler = (button) => {
    button.addEventListener('click', (e) => {
      if (e.currentTarget.tagName == 'A') return
      setCookie("country_redirected", true, 64);
      close();
    })
  }

  languageObj.forEach(language => {
    geoDropdownButtons.insertAdjacentHTML('beforeend', createButton(language))
  })

  geoDropdownButtons.querySelectorAll('.geo-dropdown__language > a')?.forEach(button => {
    buttonClickHandler(button);
  })
}

const geoDropdowns = document.querySelectorAll('.js-geo-dropdown')

if (geoDropdowns)
{
  geoDropdowns.forEach(geoDropdown => initGeoDropdown(geoDropdown))
}